import { merge } from 'lodash-es'

const INIT_STATE = {
  avatar: {
    size: 50,
    roundness: 2,
    show: true
  },
  font: {
    size: 12,
    family: 'Arial, Helvetica, sans-serif'
  },
  color: {
    main: '#00C3A5',
    mainPreview: '#00C3A5',
    secondary: '#00C3A5',
    secondaryPreview: '#00C3A5'
  },
  separator: '/'
}

export default {
  state: {
    avatar: {
      size: 50,
      roundness: 2,
      show: true
    },
    font: {
      size: 12,
      family: 'Arial, Helvetica, sans-serif'
    },
    color: {
      main: '#00C3A5',
      mainPreview: '#00c3a5',
      secondary: '#00C3A5',
      secondaryPreview: '#00C3A5'
    },
    separator: '/'
  },

  getters: {
    getOptions: state => state
  },
  mutations: {
    SET_OPTIONS (state, data) {
      state = merge(state, data)
    },
    SET_COLOR (state, data) {
      state.color = { ...state.color, ...data }
    },
    RESET_OPTIONS (state) {
      Object.keys(INIT_STATE).forEach(k => {
        state[k] = INIT_STATE[k]
      })
    },
    SET_OPTION_STATE (state, data) {
      state = Object.assign(state, data)
    }
  },
  actions: {
    async updateOptions ({ commit, dispatch, rootState }, data) {
      commit('SET_OPTIONS', data)
      if (rootState.projects.project.id) {
        await dispatch('updateProject', rootState.projects.project)
      }
    }
  }
}
